// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Meyqxh2tKbHuhpqzyv7A{color:var(--gray-60);font-size:12px;font-weight:400;padding:12px 0;display:flex;justify-content:center}`, "",{"version":3,"sources":["webpack://./src/pages/chatbot/ui/ActionsDropdown/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,oBAAA,CACA,cAAA,CACA,eAAA,CACA,cAAA,CACA,YAAA,CACA,sBAAA","sourcesContent":[".noResults {\n  color: var(--gray-60);\n  font-size: 12px;\n  font-weight: 400;\n  padding: 12px 0;\n  display: flex;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noResults": `Meyqxh2tKbHuhpqzyv7A`
};
export default ___CSS_LOADER_EXPORT___;
